import { render, staticRenderFns } from "./ProductDiscussion.vue?vue&type=template&id=08b66223&scoped=true"
import script from "./ProductDiscussion.vue?vue&type=script&lang=js"
export * from "./ProductDiscussion.vue?vue&type=script&lang=js"
import style0 from "./ProductDiscussion.vue?vue&type=style&index=0&id=08b66223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b66223",
  null
  
)

export default component.exports